import { useEffect, useRef } from 'react'
import { Box, Paper, Typography, Button, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const VARIANT_BORDER = {
  primary: 'primary.main',
  secondary: 'secondary.main',
  warning: 'warning.main',
  info: 'info.main',
}

export default function ConversationBanner({ toast, onDismiss }) {
  const timerRef = useRef(null)
  const onDismissRef = useRef(onDismiss)

  useEffect(() => {
    onDismissRef.current = onDismiss
  }, [onDismiss])

  useEffect(() => {
    if (toast?.auto_dismiss_ms) {
      timerRef.current = setTimeout(() => onDismissRef.current(), toast.auto_dismiss_ms)
    }
    return () => clearTimeout(timerRef.current)
  }, [toast])

  if (!toast) return null

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 0,
        borderLeft: '4px solid',
        borderLeftColor: VARIANT_BORDER[toast.variant] ?? 'info.main',
        borderBottom: '1px solid',
        borderBottomColor: 'divider',
        borderTop: 'none',
        borderRight: 'none',
        px: 2,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2" fontWeight="bold">{toast.title}</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>{toast.body}</Typography>
        {toast.actions?.length > 0 && (
          <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
            {toast.actions.map((action, i) => (
              <Button
                key={i}
                size="small"
                variant="outlined"
                onClick={() => {
                  if (action.url) window.open(action.url, '_blank', 'noopener,noreferrer')
                  if (action.dismiss) onDismiss()
                }}
              >
                {action.label}
              </Button>
            ))}
          </Box>
        )}
      </Box>
      <IconButton size="small" onClick={onDismiss} aria-label="Dismiss notification" sx={{ alignSelf: 'flex-start' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Paper>
  )
}
